import React, { type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import ChevronDownIcon from '@atlaskit/icon/utility/migration/chevron-down';
import Tooltip from '@atlaskit/tooltip';

export type Props = {
	isExpanded: boolean;
	label: string;
	testId?: string;
	onClick: (analyticsEvent: UIAnalyticsEvent) => void;
};

export const ExpandCollapseToggle = (props: Props) => {
	const handleCollapseChevronClick = (
		event: SyntheticEvent<HTMLElement>,
		analyticsEvent: UIAnalyticsEvent,
	) => {
		props.onClick(analyticsEvent);
	};

	return (
		<Tooltip content={props.label}>
			<Button
				appearance="subtle"
				onClick={handleCollapseChevronClick}
				iconBefore={
					<AnimatedRotation isRotated={props.isExpanded}>
						<ChevronDownIcon spacing="spacious" label={props.label} />
					</AnimatedRotation>
				}
				testId={props.testId}
			/>
		</Tooltip>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AnimatedRotation = styled.div<{ isRotated: boolean }>({
	transition: '200ms ease all',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	transform: ({ isRotated }) => (isRotated ? 'rotate(180deg)' : 'rotate(0deg)'),
});
